module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/1@2x_27e898cdecbe6714cc13fa2e9c2b919d.png";